import { ProjectsTableComponent } from '../projects-table/projects-table.component';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SubProject } from 'src/app/model/project/sub-project';
import { Adjustment } from 'src/app/model/project/adjustment';
import DateHelper from 'src/app/helpers/date-helper';
import Product from 'src/app/model/product/product';
import ProductHelper from 'src/app/helpers/product-helper';
import Board from 'src/app/model/product/board/board';

@Component({
  selector: 'pending-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PendingProjectsComponent
  extends ProjectsTableComponent
  implements OnInit
{
  ngOnInit() {
    super.ngOnInit();
    this.subProjectTypeRightMargin = true;
    this.displayedColumns = [
      'project_id',
      'company',
      'type',
      'productSize',
      'projectPlacement.address',
      'quotation',
      'design',
      'printJob',
      'finishing',
      'placement',
      'displayStatus',
      'star',
    ];
  }

  protected getLocalStorageKey(): string {
    return 'PendingProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'status/In_behandeling';
  }

  public getPageTitle(): string {
    return 'In behandeling';
  }

  // Override
  public getDefaultSort(): string {
    return 'currentConfirmedPlacementDate';
  }

  // Override
  public showImportant(subProject: SubProject) {
    return subProject.pendingImportant;
  }

  // Override
  protected preProcessProjects(projects: SubProject[]): void {
    if (projects == null) {
      return;
    }
    super.preProcessProjects(projects);
    projects.forEach((sp) => {
      if (sp.project == null) {
        return;
      }
      sp.quotationBackgroundClass = this.getQuotationBackgroundClass(sp);
      sp.quotationBadgeIcon = this.getBadgeIcon(
        false,
        sp.quotation == null ? null : sp.quotation.approved,
        sp.quotationSent,
        null,
        sp.quotationBackgroundClass
      );
      if (sp.type === 'BaseProject') {
        this.calculateBaseProjectBackgroundClasses(sp);
      } else {
        this.calculateAdjustmentBackgroundClasses(<Adjustment>sp);
        sp.project.products.forEach((p) => this.preprocessProduct(p));
      }
      this.setDisplayQuotationDate(sp);
    });
  }

  private calculateBaseProjectBackgroundClasses(subProject: SubProject): void {
    subProject.project.products.forEach((p) => {
      p.designBackgroundClass = this.getDesignBackgroundClassForProduct(p);
      p.designBadgeIcon = this.getBadgeIcon(
        p.designFinished,
        p.customerApproves,
        p.designSentToCustomer,
        null,
        p.designBackgroundClass
      );
      p.printJobBackgroundClass = this.getPrintJobBackgroundClassForProduct(p);
      p.printJobBadgeIcon = this.getBadgeIcon(
        p.printWorkReady,
        false,
        false,
        null,
        p.printJobBackgroundClass
      );
      p.finishBackgroundClass = this.getFinishingBackgroundClassForProduct(p);
      p.finishBadgeIcon = this.getBadgeIcon(
        p.finishReady,
        false,
        false,
        null,
        p.finishBackgroundClass
      );
      p.placementBackgroundClass = this.getPlacementBackgroundClassForProduct(
        subProject,
        p
      );
      p.placementBadgeIcon = this.getBadgeIcon(
        null,
        null,
        null,
        subProject.withPlacement === false
          ? null
          : subProject.projectPlacement == null
          ? null
          : subProject.projectPlacement.locationVerificationCheckedByExpert,
        p.placementBackgroundClass
      );
      p.firstPlacerDisplay =
        subProject.withPlacement === false
          ? null
          : this.getFirst(
              p.productPlacement == null ? null : p.productPlacement.placers
            );
      this.preprocessProduct(p);
    });
  }

  private calculateAdjustmentBackgroundClasses(adjustment: Adjustment): void {
    adjustment.designBackgroundClass =
      this.getDesignBackgroundClass(adjustment);
    adjustment.designBadgeIcon = this.getBadgeIcon(
      adjustment.designFinished,
      adjustment.designApproved,
      adjustment.designSentToCustomer,
      null,
      adjustment.designBackgroundClass
    );
    adjustment.printJobBackgroundClass =
      this.getPrintJobBackgroundClass(adjustment);
    adjustment.printJobBadgeIcon = this.getBadgeIcon(
      adjustment.printWorkReady,
      false,
      false,
      null,
      adjustment.printJobBackgroundClass
    );
    adjustment.finishBackgroundClass =
      this.getFinishingBackgroundClass(adjustment);
    adjustment.finishBadgeIcon = this.getBadgeIcon(
      adjustment.finishReady,
      false,
      false,
      null,
      adjustment.finishBackgroundClass
    );
    adjustment.placementBackgroundClass =
      this.getPlacementBackgroundClass(adjustment);
    adjustment.placementBadgeIcon = this.getBadgeIcon(
      null,
      null,
      null,
      adjustment.withPlacement === false
        ? null
        : adjustment.projectPlacement == null
        ? null
        : !adjustment.projectPlacement.doLocationVerification
        ? null
        : adjustment.projectPlacement.locationVerificationCheckedByExpert,
      adjustment.placementBackgroundClass
    );
    adjustment.firstPlacerDisplay =
      adjustment.withPlacement === false
        ? null
        : this.getFirst(
            adjustment.projectPlacement == null
              ? null
              : adjustment.projectPlacement.placers
          );
  }

  private preprocessProduct(product: Product) {
    if (ProductHelper.isBoard(product)) {
      ProductHelper.calculateTableBoardDisplay(<Board>product);
    }
  }

  private setDisplayQuotationDate(subProject: SubProject) {
    if (
      subProject.quotationByDate != null &&
      (subProject.quotation == null ||
        (!subProject.quotation.approved &&
          subProject.quotation.sentRegistration == null))
    ) {
      return (subProject.displayQuotationDate = DateHelper.formatDate(
        subProject.quotationByDate,
        'dd/MM'
      ));
    } else if (subProject.quotation && subProject.quotation.approved) {
      return (subProject.displayQuotationDate = DateHelper.formatDate(
        subProject.quotation.approvalRegistration.date,
        'dd/MM'
      ));
    } else if (subProject.quotation && subProject.quotation.sentRegistration) {
      return (subProject.displayQuotationDate = DateHelper.formatDate(
        subProject.quotation.sentRegistration.date,
        'dd/MM'
      ));
    } else {
      return (subProject.displayQuotationDate = '__/__');
    }
  }
}
